import { useState } from "react";
import { SlPeople } from "react-icons/sl";
import { Collapse } from "react-bootstrap";
import { BsCashCoin } from "react-icons/bs";
import { PiCalendarDotsBold } from "react-icons/pi";
import { FiFileText, FiPieChart } from "react-icons/fi";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import { LuFolderGit2, LuUserCheck } from "react-icons/lu";
import {
  IoChevronDown,
  IoChevronForward,
  IoNewspaperOutline,
} from "react-icons/io5";

/* -------------------- MENU CONFIG -------------------- */

const HR_SECTIONS = [
  {
    title: "HR Management",
    items: [
      { key: "hrAnalytics", label: "Analytics", icon: <FiPieChart /> },
      { key: "hrArtical", label: "Artical", icon: <IoNewspaperOutline /> },
      { key: "hrEvent", label: "Event", icon: <PiCalendarDotsBold /> },
      {
        key: "hrLeave",
        label: "Leave",
        icon: <FaPersonWalkingLuggage />,
        children: [
          { key: "leaveApply", label: "Apply Leave" },
          { key: "leaveBalance", label: "Balance Leave" },
          { key: "leaveCalendar", label: "Calendar Leave" },
          { key: "holidayCalendar", label: "Holiday Calendar" },
          { key: "leaveHistory", label: "Leave History" },
        ],
      },
      {
        key: "hrAttendance",
        label: "Attendance",
        icon: <LuUserCheck />,
        children: [
          { key: "attendanceInfo", label: "Attendance Info" },
          { key: "regularization", label: "Regularization & Permission" },
        ],
      },
      {
        key: "hrSalary",
        label: "Salary",
        icon: <BsCashCoin />,
        children: [
          { key: "salarySlip", label: "Salary Slip" },
          { key: "salaryReport", label: "Salary Report" },
        ],
      },
      {
        key: "hrTeams",
        label: "Teams",
        icon: <SlPeople />,
        children: [
          { key: "teamDirectory", label: "Team Library" },
          { key: "organizationChart", label: "Organization Chart" },
        ],
      },
      {
        key: "hrLibrary",
        label: "Library",
        icon: <LuFolderGit2 />,
        children: [
          { key: "myLibrary", label: "My Library" },
          { key: "globalLibrary", label: "Global Library" },
        ],
      },
      { key: "hrDocsenter", label: "Docs Center", icon: <FiFileText /> },
    ],
  },
];

/* -------------------- COMPONENT -------------------- */

const HRSidebar = ({ openHRModules, setOpenHRModules }) => {
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (key) => {
    setOpenMenu(openMenu === key ? null : key);
  };

  return (
    <>
      {/* Sidebar Menu */}
      <div className="overflow-auto" style={{ height: "calc(100vh - 55px)" }}>
        {HR_SECTIONS.map((section) => (
          <div className="channels-section mb-3" key={section.title}>
            <div className="section-title px-2 fw-bold">{section.title}</div>

            <div className="px-2">
              {section.items.map((item) => {
                const hasChildren = item.children?.length > 0;
                const isOpen = openMenu === item.key;
                return (
                  <>
                    <div
                      key={item.key}
                      className={`channel-item mb-1 d-flex justify-content-between align-items-center ${isOpen || openHRModules === item.key ? "active" : ""}`}
                      onClick={() =>
                        hasChildren
                          ? toggleMenu(item.key)
                          : setOpenHRModules(item.key)
                      }
                    >
                      <div className="hstack gap-2">
                        {item.icon}
                        <span>{item.label}</span>
                      </div>
                      {hasChildren &&
                        (isOpen ? <IoChevronDown /> : <IoChevronForward />)}
                    </div>
                    {hasChildren && (
                      <Collapse in={isOpen}>
                        <div className="ps-4">
                          {item.children.map((sub) => (
                            <div
                              key={sub.key}
                              className={`channel-item mb-1 ${openHRModules === sub.key ? "active" : ""}`}
                              onClick={() => setOpenHRModules(sub.key)}
                            >
                              ✓ {sub.label}
                            </div>
                          ))}
                        </div>
                      </Collapse>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default HRSidebar;
